import VoluntaryInformation from "./VoluntaryInformation";

export default VoluntaryInformation;
